const WorkoutBuilderActionTypes = {
  INITIALIZE_PAGE_STATE: 'INITIALIZE_PAGE_STATE',
  SET_CURRENT_EXERCISE_DETAILS_STATE: ' SET_CURRENT_EXERCISE_DETAILS_STATE',
  SET_CURRENT_WORKOUT_DETAILS_STATE: ' SET_CURRENT_WORKOUT_DETAILS_STATE',
  SET_CURRENT_PLAN_DETAILS_STATE: ' SET_CURRENT_PLAN_DETAILS_STATE',
  SET_SEND_PLAN_STATE: 'SET_SEND_PLAN_STATE',
};

export default WorkoutBuilderActionTypes;
